// Dosage comes only from the catalog: keep IU, ML, and each blend component.
export function vialLabels(name) {
  return name.split(/\s+\+\s+/).map(part => {
    const match = part.match(/\s+(\d[\d.,]*\s*(?:MG|ML|IU))\s*$/i);
    return {
      name: (match ? part.slice(0, match.index) : part).trim(),
      amount: match ? match[1].replace(/\bMG\b/i, "mg").replace(/\bML\b/i, "ml") : "",
    };
  });
}
